<template>
	<section>
		<simplert useRadius=true
		          useIcon=true
		          ref="simplert">
		</simplert>
		<div class="empty" v-if="!foodschosed.length">
			<div class="empty-text text-center">请选择所吃食物</div>
			<div class="text-center">
				<button class="btn-add" @click="poppicker()">
					<span class="iconplus">添加食物</span>
				</button>
			</div>
			<div id="name"></div>
			<div class="bgfoods">
				<img src="../assets/img/foods.png">
			</div>
		</div>
		
		<div class="foods-box" v-if="foodschosed.length">
			<ul class="foods-wrap">
				<li v-for="(foodselected,idx) in foodschosed">
					<span class="food-icon" 
					v-if="foodselected.foodThumb"
					:style="{backgroundImage:'url(' + foodselected.foodThumb + ')'}"></span>
					<div class="food-title">{{ foodselected.foodTitle }}</div>
					<div class="food-kilo">{{ foodselected.foodWeight }}g</div>
					<span class="icon-del" @click="delfood(idx)"></span>
				</li>
			</ul>
			<div class="text-center">
				<button class="btn-add" @click="poppicker()">
					<span class="iconplus">添加食物</span>
				</button>
			</div>
		</div>
		<!--<router-link to="/chosemotion" class="calculate-link">计算热量</router-link>-->
		<div class="calculate-link" @click="calculate()">计算热量</div>
	</section>
</template>

<script>
import Picker from 'better-picker'
import Simplert from 'vue2-simplert'

export default {
	components: {Simplert},
	computed : {
      foodschosed () {
        return this.$store.state.phfoodlist
      },
      foodweights () {
      	return this.$store.state.foodweights
      }
    },
    data() {
        return {
          loading:true,
          finished:false,
          foodcats:[],
          foods:[],
          title: '热量计算'
        }
    },
    head: {
		title: function () {
			return {
				inner: this.title,
				separator: ' ', 
        		complement: ' '
			}
		}
	},
    created(){
    	this.axios.get(apiurl_foodcats).then((response) => {
			var data1 = []
          	var len = response.data.length
          	for(let i = 0; i<len;i++){
          		data1[i] = {
          			text:response.data[i].name,
          			value:response.data[i].id
          		}
          		// get foods
          		this.axios.get(apiurl_foods + response.data[i].id).then((responsefood) => {
					var foodsresult = responsefood.data
					
					var foods_len = responsefood.data.length
					var foods_arr = []
					for(var j = 0; j<foods_len; j++){
						var codestr = foodsresult[j].meta_box.sport_food_code
						var thumburl = ''
						if(codestr){
							for(var k=codestr.length;k<4;k++ ){
								codestr = '0' + codestr
							}
							thumburl = food_thumb_api + 'sport/' + codestr + '.jpg!food'
						}
							
						foods_arr[j] = {
							text:foodsresult[j].title.rendered,
							value:foodsresult[j].id,
							foodthumb:thumburl,
							food_useable_percent:foodsresult[j].meta_box.sport_food_index,
							food_calorie:foodsresult[j].meta_box.sport_food_calorie
						}
					}
					this.foods[i] = foods_arr
				})
          		// end get foods
          	}
          	this.foodcats = data1
		})

    },
    methods:{
    	poppicker(){
    		var interv;
		    interv = setInterval(() => {
		      if(this.foods.length > 0){
		      	clearInterval(interv)
		      	//
		      	var data1 = this.foodcats
		      	var data2 = this.foods[0]
		      	var data3 = this.foodweights
		      	var picker = new Picker({
					data: [data1, data2, data3],
					selectedIndex: [0, 1, 2],
					title: '选择食物'
				});
				var _that = this
				picker.on('picker.change', function (index, selectedIndex) {
					if(index == 0){
						var second = _that.foods[selectedIndex]
						picker.refillColumn(1, second);
					}

				});
				picker.on('picker.select', function (selectedVal, selectedIndex) {
					data2 = _that.foods[selectedIndex[0]]
					if(_that.foodschosed.length){
						for(var i=0;i<_that.foodschosed.length;i++){
							if(_that.foodschosed[i].id == data2[selectedIndex[1]].value){
								var objtemp = {
									obj_weight : data3[selectedIndex[2]].value,
									obj_index  : i
								}
								_that.$store.dispatch('phAddWeight',objtemp)
								_that.removePicker()
								return false;
							}
						}
						var temp_arr = {
							id:data2[selectedIndex[1]].value,
							foodTitle: data2[selectedIndex[1]].text,
							foodWeight: data3[selectedIndex[2]].value,
							foodThumb: data2[selectedIndex[1]].foodthumb,
							foodUseable: data2[selectedIndex[1]].food_useable_percent,
							foodCalorie: data2[selectedIndex[1]].food_calorie
						}
						_that.$store.dispatch('savePhfood',temp_arr)
					}else{
						var temp_arr = {
							id:data2[selectedIndex[1]].value,
							foodTitle: data2[selectedIndex[1]].text,
							foodWeight: data3[selectedIndex[2]].value,
							foodThumb: data2[selectedIndex[1]].foodthumb,
							foodUseable: data2[selectedIndex[1]].food_useable_percent,
							foodCalorie: data2[selectedIndex[1]].food_calorie
						}
						_that.$store.dispatch('savePhfood',temp_arr)
					}
					_that.removePicker()
					

				})
				picker.on('picker.cancel',function(){
					_that.removePicker()
				})
				picker.on('picker.valuechange', function (selectedVal, selectedIndex) {
				});
				picker.show();
				document.getElementsByClassName('picker')[0].className += ' three' 
		      	//
		      }
		    }, 50)

    		///
    	},
    	delfood(idx){
    		this.$store.dispatch('deletePhfood',idx)
    	},
    	calculate(){
    		
    		if(!this.foodschosed.length){
    			//
    			let obj = {
				    message: '请选择所吃食物',
				    type: 'error',
				    customCloseBtnText:'确定'
				}
				this.$refs.simplert.openSimplert(obj)
    			///
    		}else{
    			this.$router.push({ path: '/chosemotion'});
    		}
    	}
    }
}
</script>


// WEBPACK FOOTER //
// chosefood.vue?18e6947d